import React from "react";
import "./particle.css";
import LecturersComponent from "./Lecturers";
export default function Particle() {
  return (
    <div>
      <div class="containerParticle">
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>

        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <LecturersComponent />
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
        <div class="circle-container">
          <div class="circle"></div>
        </div>
      </div>
    </div>
  );
}
